export default __webpack_public_path__ + "static/media/22.dc66e9f2.png";